import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { QuoteService } from 'src/app/services/quote.service';
import { HelperService } from 'src/app/services/helper.service';
import { NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-user-access-list',
  templateUrl: './user-access-list.component.html'
})
export class UserAccessListComponent implements OnInit, OnChanges {

  @Input() quoteId: number = 0;
  @Input() maxUsers: number = 20;
  @Input() height: string = '350px';


  userAccessList: any = [];
  userSearchResults: any = [];
  keyword: string = "fullName";
  allowedUserId: number = 0;

  defaultColDef: any = {
    flex: 1,
    resizable: true,
    floatingFilter: true,
    wrapHeaderText: true
  };

  userAccessColumnDefs: any = [
    
    {
      headerName: 'Given name', field:'givenName', sortable: true, filter: 'agTextColumnFilter', maxWidth: 250, minWidth: 150
    },
    
    {
      headerName: 'User role', field:'role', sortable: true, filter: 'agTextColumnFilter', maxWidth: 175, minWidth: 150
    },
    {
      headerName: 'Email', field:'email', sortable: true, filter: 'agTextColumnFilter', maxWidth: 275, minWidth: 150
    },
    {
      headerName: 'Phone', field:'phone', sortable: true, filter: 'agTextColumnFilter', maxWidth: 175, minWidth: 150
    },
    {
      headerName: 'Mobile', field:'mobile', sortable: true, filter: 'agTextColumnFilter', maxWidth: 175, minWidth: 150
    },
     {
      headerName: 'Is Active?', field:'isActive', sortable: true, filter: 'agTextColumnFilter', maxWidth: 175, minWidth: 150
    },
     {
      headerName: 'Is Locked?', field:'isLocked', sortable: true, filter: 'agTextColumnFilter', maxWidth: 175, minWidth: 150
    },
     {
      headerName: 'Last logged in', valueGetter: params => params.data.lastLoggedIn != null? this.helperService.dateFormat(params.data.lastLoggedIn,'DD/MM/YYYY') : "", sortable: true, filter: 'agTextColumnFilter', maxWidth: 175, minWidth: 150
    }
  ];

  constructor(
    private quoteService: QuoteService,
    private helperService: HelperService,
  ) { }

  ngOnInit(): void {
    if (this.quoteId > 0) {
      this.loadUserAccessList();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['quoteId'] && !changes['quoteId'].firstChange) {
      // quoteId has changed and it's not the initial change
      if (this.quoteId > 0) {
        this.loadUserAccessList();
      } else {
        this.userAccessList = []; // Clear list if quoteId is 0 or invalid
      }
    }
  }

  loadUserAccessList(): void {
    if (this.quoteId === 0) return;
    
    this.quoteService.getUserAccessList(this.quoteId).subscribe((result: any) => {
      this.userAccessList = result;
    });
  }

  onUserAccessGridReady(params: any): void {
    // Grid ready event for user access grid
    params.api.sizeColumnsToFit();
  }

  userSelected($event: any): void {
    this.allowedUserId = Number($event.id);    
  }

}
